const mutations = {
  mutationPersonalLines(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.personalLines[payload.tab] = payload.responseData;
    } else {
      state.personalLines = payload;
    }
  },

  mutationPersonalLinesMeta(state, payload) {
    state.personalLinesMeta = payload;
  },

  mutationQuickViews(state, payload) {
    state.quickViews = payload;
  },

  mutationPersonalLineDetail(state, payload) {
    state.personalLine = payload;
  },

  mutationListProductCategory(state, payload) {
    state.listProductCategory = payload;
  },
  mutationListInsuranceBranch(state, payload) {
    state.listInsuranceBranch = payload;
  },
};

export default mutations;
